import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cbse',
  templateUrl: './cbse.component.html',
  styleUrls: ['./cbse.component.scss']
})
export class CbseComponent implements OnInit {
  pdfSrc='/assets/pdf/2024_RESULT.pdf';
  pdfSrc1='/assets/pdf/cbse_result.pdf';
  isLoading=[true,true];
  constructor() { }

  ngOnInit(): void {
  }
  hideLoader(i){
    this.isLoading[i]=false;
  }
}
